import { render, staticRenderFns } from "./VersiControl.vue?vue&type=template&id=30381476&scoped=true"
import script from "./VersiControl.vue?vue&type=script&lang=js"
export * from "./VersiControl.vue?vue&type=script&lang=js"
import style0 from "./VersiControl.vue?vue&type=style&index=0&id=30381476&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30381476",
  null
  
)

export default component.exports